import { BaseEntity, PaginatedEntity } from '@core/entities/_extra';
import { Expose, Transform, Type } from 'class-transformer';

export class TagsListEntity extends PaginatedEntity {
  @Type(() => TagEntity)
  tags: TagEntity[];
}

export class TagEntity extends BaseEntity {
  @Expose({ name: 'tag_name' })
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  tagName: string | null;

  type: string | null;

  @Expose({ name: 'timestamp' })
  @Type(() => Date)
  timeStamp: string;
}
